import { render, staticRenderFns } from "./PainelItemLegado.vue?vue&type=template&id=06334257&scoped=true"
import script from "./PainelItemLegado.vue?vue&type=script&lang=js"
export * from "./PainelItemLegado.vue?vue&type=script&lang=js"
import style0 from "./PainelItemLegado.vue?vue&type=style&index=0&id=06334257&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06334257",
  null
  
)

export default component.exports